import { List } from 'immutable';

export function generateSelectEntityById(entitySelector) {
  return (id) => (state) => entitySelector(state).get(id);
}

export function generateSelectEntityByEntityInfo(entitySelector, EntityModel) {
  const selectById = generateSelectEntityById(entitySelector);
  return (entityInfo) => selectById(EntityModel.getId(entityInfo));
}

export function generateSelectEntitiesByIdsList(entitySelector) {
  return (ids = List(), filtered = true) => (state) => {
    const entityCollection = entitySelector(state);
    const entities = ids?.map((id) => entityCollection.get(id));
    return filtered ? entities?.filter((entity) => !!entity) : entities;
  };
}

export function generateSelectEntitiesByEntitiesList(entitySelector, EntityModel) {
  const selectByIds = generateSelectEntitiesByIdsList(entitySelector);
  return (entities, filtered = true) => selectByIds(
    entities?.map((entity) => EntityModel.getId(entity)),
    filtered,
  );
}
